import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import App from "next/app";
import React from 'react';
import { StoreProvider } from 'store/zustandProvider';
import { useHydrate } from 'store/store'; //SEO

import { DefaultSeo } from 'next-seo';
import SEO from '../next-seo.config';
import { SWRConfig } from 'swr';
//STYLES
//import '../styles/antd.less';
import '../styles/styles.scss';

require('../styles/antd.less');

import { useDebugger } from 'components/commons/DebugComponent';
import fetchJson from 'lib/fetchJson';

function MyApp(context) {
  //@ts-ignore
  var Component = context.Component,
      pageProps = context.pageProps;
  var store = useHydrate(pageProps.initialZustandState);
  useDebugger();
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsxs(SWRConfig, {
      value: {
        fetcher: fetchJson,
        //refreshInterval: 3000,
        onError: function onError(err) {
          console.error('SWR ERROR', err);
        }
      },
      children: [/*#__PURE__*/_jsx(DefaultSeo, _objectSpread({}, SEO)), /*#__PURE__*/_jsx(StoreProvider, {
        store: store,
        children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
      })]
    })
  });
}

export default MyApp;